import { StyledEngineProvider } from "@mui/material/styles";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Routes from "./routes/Routes";
import { BrowserRouter, useLocation } from "react-router-dom"; // MODIFICADO: Agregado useLocation
import { useEffect } from "react"; // AGREGADO: Para tracking de Meta Pixel

const theme = createTheme({
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          maxHeight: "80vh!important",
        },
        cell: {
          backgroundColor: "#FFF",
          fontSize: "0.86rem",
        },
      },
    },

    MuiPickersCalendarHeader: {
      styleOverrides: {
        iconButton: {
          color: "red",
        },
      },
    },

    MuiPickersDay: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "#FF0000",
            "&:hover": {
              backgroundColor: "#FF0000",
            },
          },
          "&.Mui-current": {
            color: "#FF0000",
          },
        },
      },
    },

    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#FF0000",
        },
      },
    },

    MuiDataGridFilterPanel: {
      styleOverrides: {
        root: {
          minWidth: "300px",
        },
      },
    },

    MuiToolbar: {
      styleOverrides: {
        root: {
          color: "#FFF",
        },
      },
    },

    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "#FFF",
        },
      },
    },

    MuiInputBase: {
      styleOverrides: {
        root: {
          color: "#000000",
        },
      },
    },

    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFF",
          color: "#000",
        },
      },
    },

    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "white",
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        elevation0: {
          height: "35vh",
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: "none",
        },
      },
    },
  },

  palette: {
    primary: {
      main: "#4669E8",
    },
    secondary: {
      main: "#ffffff",
    },
  },
});

// NUEVO: Componente interno para tracking de Meta Pixel
function MetaPixelTracking() {
  const location = useLocation();

  useEffect(() => {
    // Función que intenta ejecutar el PageView con reintentos
    const trackPageView = (retries = 0) => {
      if (window.fbq) {
        // Meta Pixel está disponible, ejecutar tracking
        console.log('✅ Meta Pixel tracking:', location.pathname);
        window.fbq('track', 'PageView');
      } else if (retries < 10) {
        // Meta Pixel aún no está cargado, reintentar en 100ms
        console.log('⏳ Esperando Meta Pixel... intento', retries + 1);
        setTimeout(() => trackPageView(retries + 1), 100);
      } else {
        // Después de 10 intentos (1 segundo), reportar error
        console.error('❌ Meta Pixel no disponible después de 1 segundo');
      }
    };

    trackPageView();
  }, [location]); // Se ejecuta cada vez que cambia la URL

  return null;
}

function App() {
  return (
    <>
      <BrowserRouter>
        <MetaPixelTracking /> {/* MODIFICADO: Tracking integrado en App.jsx */}
        <ThemeProvider theme={theme}>
          <StyledEngineProvider injectFirst>
            <Routes />
          </StyledEngineProvider>
        </ThemeProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
